import { createContext, useEffect, useState } from "react";

export const AuthEmpleadoContext = createContext();

export const AuthEmpleadoProvider = ({ children }) => {
  const [empleado, setEmpleado] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("empleadoSession");
    if (stored) {
      setEmpleado(JSON.parse(stored));
    }
  }, []);

  const loginEmpleado = (data) => {
    localStorage.setItem("empleadoSession", JSON.stringify(data));
    setEmpleado(data);
  };

  const logoutEmpleado = () => {
    localStorage.removeItem("empleadoSession");
    setEmpleado(null);
  };

  return (
    <AuthEmpleadoContext.Provider
      value={{ empleado, loginEmpleado, logoutEmpleado }}
    >
      {children}
    </AuthEmpleadoContext.Provider>
  );
};
